/** CSS contract: css-library/components/01-leaves/radio.css. */
import type { Ref } from 'react';
import type { HTMLAttributes, InputHTMLAttributes, ReactNode, TableHTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  chip?: boolean;
  children?: ReactNode;
}

export function Radio(
  { ref, chip = false, className, children, ...rest }: RadioProps & { ref?: Ref<HTMLInputElement> },
) {
  return (
    <label className={cx('radio-row', chip && 'is-chip', className)}>
      <input type="radio" ref={ref} {...rest} />
      <span className="radio" />
      {children != null && <span className="radio-label">{children}</span>}
    </label>
  );
}

export interface RadioGroupProps extends HTMLAttributes<HTMLDivElement> {
  stacked?: boolean;
}

export function RadioGroup(
  { ref, stacked = false, className, children, ...rest }: RadioGroupProps & { ref?: Ref<HTMLDivElement> },
) {
  return (
    <div ref={ref} className={cx('radio-group', stacked && 'is-stacked', className)} {...rest}>
      {children}
    </div>
  );
}

export type RadioMatrixProps = TableHTMLAttributes<HTMLTableElement>;

export function RadioMatrix(
  { ref, className, children, ...rest }: RadioMatrixProps & { ref?: Ref<HTMLTableElement> },
) {
  return (
    <table ref={ref} className={cx('radio-matrix', className)} {...rest}>
      {children}
    </table>
  );
}
